(() => {
  if (window.__belnayViewTransitions) return;
  window.__belnayViewTransitions = true;

  const warmed = [];

  function isProductUrl(url) {
    if (!url) return false;
    try {
      const path = new URL(url, window.location.origin).pathname;
      return path.indexOf("/products/") !== -1 && path.indexOf("shipping-protection") === -1;
    } catch (err) {
      return String(url).indexOf("/products/") !== -1;
    }
  }

  function rememberWarm(key) {
    if (warmed.indexOf(key) !== -1) return false;
    warmed.push(key);
    if (warmed.length > 16) warmed.shift();
    return true;
  }

  function enlargeImageUrl(src) {
    if (!src) return "";
    try {
      const url = new URL(src, window.location.origin);
      if (url.searchParams.has("width")) {
        const width = parseInt(url.searchParams.get("width"), 10) || 0;
        if (width >= 1200) return url.href;
        url.searchParams.set("width", "1600");
        return url.href;
      }
      url.pathname = url.pathname.replace(/_(\d+)x(\d*)(\.[a-z0-9]+)?$/i, "_1600x$3");
      return url.href;
    } catch (err) {
      return src;
    }
  }

  function warmProduct(url, img, includeQuickView) {
    if (!isProductUrl(url)) return;
    try {
      const next = new URL(url, window.location.origin);
      next.searchParams.delete("vt");
      /* Product pages are served no-store, so a fetch() of the document never feeds
         the navigation: browsers without speculation rules downloaded every page twice. */
      if (includeQuickView && rememberWarm(`qv:${next.pathname}`)) {
        const qv = new URL(next.href);
        qv.searchParams.set("view", "quickview");
        fetch(qv.href, { credentials: "same-origin", priority: "low" }).catch(() => {});
      }
    } catch (err) {
      /* ignore */
    }
    const src = img && (img.currentSrc || img.src);
    if (!src) return;
    const big = enlargeImageUrl(src);
    if (!big || !rememberWarm(`img:${big}`)) return;
    const prefetch = document.createElement("link");
    prefetch.rel = "prefetch";
    prefetch.as = "image";
    prefetch.href = big;
    document.head.appendChild(prefetch);
  }

  function productLinkFromEvent(event) {
    /* A finger fires pointerdown on every scroll that starts on a card: only a mouse warms anything. */
    if (event.pointerType === "touch") return;
    const qv = event.target.closest("[data-quick-view-open]");
    if (qv) {
      const url = qv.getAttribute("data-product-url");
      const card = qv.closest("[data-product-card], .impulse-card, .search-card, .home-exhibit__card");
      const img = card ? card.querySelector("img") : null;
      if (url) warmProduct(url, img, true);
      return;
    }
    if (event.target.closest("button, [data-card-prev], [data-card-next], [data-quick-view-modal]")) return;
    const link = event.target.closest('a[href*="/products/"]');
    if (!link || !isProductUrl(link.getAttribute("href") || link.href || "")) return;
    const media = link.closest("[data-view-transition-to-main-product]") || link;
    const img = media.querySelector("img") || link.querySelector("img");
    warmProduct(link.href, img, false);
  }

  document.addEventListener("pointerover", productLinkFromEvent, true);
  document.addEventListener("pointerdown", productLinkFromEvent, true);
})();
